let PATH = '';
let SHOULD_REFRESH = false;

const handlesEnum = {
    user: () => handleUserKey(),
    lastModule: (newValue) => handleLastModule(newValue)
};

export default function (VUE_APP_SIGN_IN_URL = '', shouldRefresh = false) {
    PATH = VUE_APP_SIGN_IN_URL;
    SHOULD_REFRESH = shouldRefresh;

    return (onstorage = (event) => {
        handlesEnum?.[event?.key]?.(event?.newValue, event?.oldValue);
    });
}

function handleUserKey() {
    let lastModule = localStorage.getItem('lastModule');
    lastModule = lastModule === 'null' ? null : lastModule;

    window.location.href = `${PATH}#/sign-in?module=${lastModule || 'CENTRAL'}`;

    refreshPage();
}

function handleLastModule(newModule) {
    if (newModule || newModule != 'null') {
        window.location.href = `${PATH}#/sign-in?module=${newModule}`;

        refreshPage();
    }
}

function refreshPage() {
    if (SHOULD_REFRESH) {
        setTimeout(() => {
            location.reload();
        }, 200);
    }
}
